export default {
    apiUrl: "https://odeme-api.isimicin.co/api",
    apiContentUrl : "https://odeme-api.isimicin.co/Content/CardLogo",
    // apiUrl: "https://test-b2b-api.finekra.com/api",
    //apiUrl: "https://test-b2b-api.finekra.com/api"
}